import apiClient from "../api/axiosConfig";

export const getEnums = async (country) =>
    apiClient.feesAPI.get(`/api/v1/feeAdmin/getEnums`);
